import _ from 'lodash'

export const LOAD_TASK_STATUS = {
  PENDING: 'PENDING',
  STARTED: 'STARTED',
  FIRST_INIT: 'FIRST_INIT',
  APPLY_HARD_CONDITION: 'APPLY_HARD_CONDITION',
  EMPTY_AFTER_HARD_CONDITION: 'EMPTY_AFTER_HARD_CONDITION',
  APPLY_SOFT_CONDITION: 'APPLY_SOFT_CONDITION',
  EMPTY_AFTER_SOFT_CONDITION: 'EMPTY_AFTER_SOFT_CONDITION',
  CREATE_RECOMMENDED_INFO: 'CREATE_RECOMMENDED_INFO',
  RANG_AND_SUMMARY_RECOMMENDED_INFO: 'RANG_AND_SUMMARY_RECOMMENDED_INFO',
  SAVE_RECOMMENDED_INFO: 'SAVE_RECOMMENDED_INFO',
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
  FAILED_TIMEOUT: 'FAILED_TIMEOUT',
  RETRY_PENDING: 'RETRY_PENDING',

  isFinished: (status) => _.includes([LOAD_TASK_STATUS.FINISHED], status),
  isEmpty: (status) => _.includes([LOAD_TASK_STATUS.EMPTY_AFTER_HARD_CONDITION, LOAD_TASK_STATUS.EMPTY_AFTER_SOFT_CONDITION], status),
  isFailed: (status) => _.includes([LOAD_TASK_STATUS.FAILED, LOAD_TASK_STATUS.FAILED_TIMEOUT], status),
  isRunning: (status) => !_.includes([LOAD_TASK_STATUS.FINISHED, LOAD_TASK_STATUS.FAILED, LOAD_TASK_STATUS.FAILED_TIMEOUT, LOAD_TASK_STATUS.EMPTY_AFTER_HARD_CONDITION, LOAD_TASK_STATUS.EMPTY_AFTER_SOFT_CONDITION], status)
}
